// extracted by mini-css-extract-plugin
module.exports = {"bottomDesc":"OtpSetupModal_bottomDesc__wnZxT"};